import { createContext } from 'react';
import { RootStore } from './root';

export const storeContext = createContext<RootStore>(null);
